module.exports = __webpack_public_path__ + "dashboard/img/upload.8e45e55dbb307d68b6355f712a4774bd.svg";